// extracted by mini-css-extract-plugin
export default {"container":"PromptMessage_container__Pr6cz","message":"PromptMessage_message__1xtDJ","button_group":"PromptMessage_button_group__rjsXx"};